
























import Vue from 'vue';

import Header from './components/Header.vue';
import Button from './components/Button.vue';
import Faq from './components/Faq.vue';
import Questionnaire from './components/Questionnaire.vue';
import Ranking from './components/Ranking.vue';

export default Vue.extend({
  name: 'App',
  components: {
    Button,
    Faq,
    Header,
    Questionnaire,
    Ranking,
  },
  data() {
    return {
      tab: 2,
    };
  },
  methods: {
    isActive(i: number): boolean {
      return this.tab === i;
    },
    setTab(i: number): void {
      this.tab = i;
    },
  },
});
